import { Container } from 'inversify';
import 'reflect-metadata';
import {
  LookupService,
  IdentityService,
  SubscriptionService,
  EmailService,
  UserActivityService,
  BrandReportService,
  BrandService,
  PurchaseService,
  CategoryService,
  NewsService,
  CategoryInsightDownloadsService,
  CategoryInsightsService,
  CategoryFoldersService,
  MarketInsightsService,
  UserNotificationService,
  AlertService,
  FeedbackService,
  MarketSnapshotService,
  UserTwoFactorService,
  TradewindsService,
  TicketService,
} from '.';
import { MaintenanceService } from './maintenance.service';
import { OSCXService } from './oscx.service';
import { DigitalShelfService } from './digital-shelf.service';
import { OrganizationService } from './organization.service';
const container = new Container();

container
  .bind<LookupService>('LookupService')
  .to(LookupService)
  .inSingletonScope();
container
  .bind<IdentityService>('IdentityService')
  .to(IdentityService)
  .inSingletonScope();
container
  .bind<EmailService>('EmailService')
  .to(EmailService)
  .inSingletonScope();
container
  .bind<SubscriptionService>('SubscriptionService')
  .to(SubscriptionService)
  .inSingletonScope();
container
  .bind<UserActivityService>('UserActivityService')
  .to(UserActivityService)
  .inSingletonScope();
container
  .bind<BrandReportService>('BrandReportService')
  .to(BrandReportService)
  .inSingletonScope();

container
  .bind<BrandService>('BrandService')
  .to(BrandService)
  .inSingletonScope();

container
  .bind<PurchaseService>('PurchaseService')
  .to(PurchaseService)
  .inSingletonScope();

container
  .bind<CategoryService>('CategoryService')
  .to(CategoryService)
  .inSingletonScope();

container.bind<NewsService>('NewsService').to(NewsService).inSingletonScope();

container
  .bind<CategoryInsightsService>('CategoryInsightsService')
  .to(CategoryInsightsService)
  .inSingletonScope();

container
  .bind<CategoryInsightDownloadsService>('CategoryInsightDownloadsService')
  .to(CategoryInsightDownloadsService)
  .inSingletonScope();

container
  .bind<CategoryFoldersService>('CategoryFoldersService')
  .to(CategoryFoldersService)
  .inSingletonScope();

container
  .bind<MarketInsightsService>('MarketInsightsService')
  .to(MarketInsightsService)
  .inSingletonScope();

container
  .bind<UserNotificationService>('UserNotificationService')
  .to(UserNotificationService)
  .inSingletonScope();

container
  .bind<AlertService>('AlertService')
  .to(AlertService)
  .inSingletonScope();

container
  .bind<FeedbackService>('FeedbackService')
  .to(FeedbackService)
  .inSingletonScope();

container
  .bind<MarketSnapshotService>('MarketSnapshotService')
  .to(MarketSnapshotService)
  .inSingletonScope();

container
  .bind<UserTwoFactorService>('UserTwoFactorService')
  .to(UserTwoFactorService);

container
  .bind<MaintenanceService>('MaintenanceService')
  .to(MaintenanceService)
  .inSingletonScope();

container
  .bind<TradewindsService>('TradewindsService')
  .to(TradewindsService)
  .inSingletonScope();

container.bind<OSCXService>('OSCXService').to(OSCXService).inSingletonScope();

container
  .bind<DigitalShelfService>('DigitalShelfService')
  .to(DigitalShelfService)
  .inSingletonScope();

container
  .bind<OrganizationService>('OrganizationService')
  .to(OrganizationService)
  .inSingletonScope();

container
  .bind<TicketService>('TicketService')
  .to(TicketService)
  .inSingletonScope();

export default container;
